import { FC, useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';

import { DataFilterControl, DataFilterRequest } from '../../../../../hooks/DataFilter/DataFilterControl';
import Row from '../../../../../components/Row';

import { DspAudience as DspAudienceSource } from '../../../../../types/DspAudience';

interface CampaignAdGroupAudienceTargetingDataGridFilterProps {
    rows: DspAudienceSource[];
    onFilterChange?: (filteredRows: DspAudienceSource[]) => void;
}

const CampaignAdGroupAudienceTargetingDataGridFilter: FC<CampaignAdGroupAudienceTargetingDataGridFilterProps> = ({
    rows,
    onFilterChange,
}) => {
    const [filterRequest, setFilterRequest] = useState<DataFilterRequest<DspAudienceSource>>({
        filters: [],
        page: 1,
        pageSize: 25,
    });

    const audienceSourceCategoryOptions = useMemo(() => Array.from(new Set(rows.map((r) => r.category))), [rows]);

    const filteredRows = useMemo(() => {
        return filterRequest.filters.reduce<DspAudienceSource[]>((acc, crit) => {
            if (crit.operator === 'equals') {
                return acc.filter((r) => r[crit.field] === crit.value);
            }
            return acc;
        }, rows);
    }, [rows, filterRequest]);

    useEffect((): void => {
        onFilterChange?.(filteredRows);
    }, [filteredRows, onFilterChange]);

    return (
        <Row>
            <Box width={320}>
                <DataFilterControl<DspAudienceSource>
                    filterRequest={filterRequest}
                    onFilterChange={setFilterRequest}
                    field="category"
                    label="Audience Category"
                    options={audienceSourceCategoryOptions}
                />
            </Box>
        </Row>
    );
};

export default CampaignAdGroupAudienceTargetingDataGridFilter;
